module.exports = __webpack_public_path__ + "img/img4.b111afe5.png";